import { useCallback, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { listMaterials, validateMaterial } from '../api/quality.js';
import { ApiError } from '../api/client.js';

export function MaterialValidationPage(): ReactNode {
  const { id = '' } = useParams<{ id: string }>();
  const { token } = useAuth();
  const [rows, setRows] = useState<readonly unknown[]>([]);
  const [form, setForm] = useState({ executionMaterialId: '', materialCode: '', approvedQty: '', consumedQty: '' });
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setRows(await listMaterials(id, token)); } catch (err) { setError(err instanceof ApiError ? err.message : 'Load failed'); }
  }, [id, token]);
  useEffect(() => { void load(); }, [load]);

  async function submit(): Promise<void> {
    setError(null); setMsg(null); setBusy(true);
    try {
      await validateMaterial(id, {
        executionMaterialId: form.executionMaterialId,
        materialCode: form.materialCode,
        approvedQty: Number(form.approvedQty),
        consumedQty: Number(form.consumedQty),
      }, token);
      setMsg('Saved'); await load();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Save failed');
    } finally { setBusy(false); }
  }

  return (
    <main aria-label="material-validation">
      <h1>Material validation — {id}</h1>
      {error ? <div role="alert">{error}</div> : null}
      {msg ? <div role="status">{msg}</div> : null}
      <div aria-label="material-count">{rows.length} record(s)</div>
      <form aria-label="material-form" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        <label>Execution Material ID<input aria-label="execMatId" value={form.executionMaterialId} onChange={(e) => setForm({ ...form, executionMaterialId: e.target.value })} required /></label>
        <label>Material code<input aria-label="materialCode" value={form.materialCode} onChange={(e) => setForm({ ...form, materialCode: e.target.value })} required /></label>
        <label>Approved Qty<input aria-label="approvedQty" value={form.approvedQty} onChange={(e) => setForm({ ...form, approvedQty: e.target.value })} required /></label>
        <label>Consumed Qty<input aria-label="consumedQty" value={form.consumedQty} onChange={(e) => setForm({ ...form, consumedQty: e.target.value })} required /></label>
        <button type="submit" disabled={busy}>Validate</button>
      </form>
    </main>
  );
}
